// prettier-ignore
// @ts-expect-error incompatibility with node16 resolution
import type { PortableTextBlock, PortableTextMarkDefinition } from '@portabletext/types';
import { Link as ScrollLink } from "react-scroll"

type Props = PortableTextBlock & {
    mark: PortableTextMarkDefinition & {
        target?: string;
    };
};

export default function LinkAnchorAnnotation({ children, mark }: Props) {
    if (!mark?.target) {
        return null;
    }

    return (
        <ScrollLink
            className="btn-standard"
            to={mark?.target}
            offset={0}
            smooth={true}
        >
            <>{children}</>
        </ScrollLink>
    );
}
